<template>
  <div>
    <input v-model="firstField.label" type="hidden" >
    <div v-if="multiple">
      <template v-if="valueAsArray ? valueAsArray.length : false">
        <input v-for="(option, key) in valueAsArray" :key="key" v-model="option.label" type="hidden" >
      </template>
    </div>
    <!-- #validation -->
    <div
      class="mt-select mt-select--block fou-select dropdown v-select"
      :class="[dropdownClasses, { 'mt-select--error': isError, 'mt-select--warn': isWarning , 'mt-select--disabled': disabled, 'fou-select--truncate-label': truncateLabel}]"
    >
      <div ref="toggle"
:class="[customField == 'region' ? 'customize-toggle' : customField == 'customized' ? 'customized-toogle': customField == 'address' ? 'customized-country-toogle' : 'dropdown-toggle']"
@mousedown.prevent="toggleDropdown">
        <div v-if="!tagsOutside">
          <template v-if="multiple">
            <span v-for="option in valueAsArray" :key="option.index" class="selected-tag mt-tag mt-serif">
              {{ getOptionLabel?.(option) }}
              <button type="button" class="close" @click="deselect(option)" />
            </span>
          </template>
          <span v-else-if="!isMultiple && (_value?.length !== 0)"
:class="['selected-tag selected-tag--pure mt-tag mt-tag--pure mt-serif']">
            {{ _value && getOptionLabel?.(_value) }}
          </span>
          <span :class="['customToggle']">▲</span>
        </div>
        <input
          v-if="!isMulitpleSelectWithNoSearch"
          :id="getId()"
          ref="search"
          v-model="search"
          :disabled="disabled"
          :data-qa-id="dataQaId"
          :autocomplete="disableAutoComplete ? 'off' : 'true'"
          type="search"
          :class="[customField == 'region' ? 'form-control mt-input mt-serif inputplaceholderCustom':'form-control mt-input mt-serif inputplaceholder', inputClass]"
          :placeholder="searchPlaceholder"
          :readonly="!searchable"
          :maxlength="maxLength"
          :name="name"
          @keydown.delete="maybeDeleteValue"
          @keyup.delete="onDelete(search)"
          @keyup.esc="onEscape"
          @keydown.up.prevent="typeAheadUp"
          @keydown.down.prevent="typeAheadDown"
          @keyup.enter.prevent="typeAheadSelect(search)"
          @keydown.enter.prevent="onEnter(search)"
          @blur="onSearchBlur"
          @focus="onSearchFocus"
        >
        <input
          v-if="isMulitpleSelectWithNoSearch"
          :id="getId()"
          ref="search"
          v-model="inputValueInSingleString"
          :data-qa-id="dataQaId"
          :disabled="disabled"
          :autocomplete="disableAutoComplete ? 'off' : 'true'"
          type="text"
          class="form-control mt-input mt-serif"
          :placeholder="searchPlaceholder"
          :readonly="isMulitpleSelectWithNoSearch"
          :maxlength="maxLength"
          :name="name"
          @keydown.delete="maybeDeleteValue"
          @keyup.delete="onDelete(search)"
          @keyup.esc="onEscape"
          @keydown.up.prevent="typeAheadUp"
          @keydown.down.prevent="typeAheadDown"
          @keyup.enter.prevent="typeAheadSelect(search)"
          @keydown.enter.prevent="onEnter(search)"
          @blur="onSearchBlur"
          @focus="onSearchFocus"
        >
        <label
          v-if="showLabel"
          :class="labelClass"
          :for="labelName"
        >{{ labelName }}</label>
        <span
          v-if="see === 'triangle' && !noDrop && !searchForbidden()"
          ref="openIndicator"
          role="presentation"
          class="open-indicator"
          :style="[{display: 'block', height: '0.625rem', width: '0.625rem'}]"
        />
        <span
          v-if="see === 'search' && !noDrop && !searchForbidden()"
          ref="openIndicator"
          role="presentation"
          class="mt-icon mt-icon-zoom search-indicator"
        />
        <span v-if="see === 'na' && !noDrop && !searchForbidden()" ref="openIndicator" role="presentation" />
        <slot name="spinner">
          <div v-show="mutableLoading" class="spinner">
            {{ $t('components.forms.fou_select.loading') }}
          </div>
        </slot>
      </div>
      <transition :name="transition">
        <ul
          v-if="dropdownOpen && !searchForbidden() && !disabled"
          ref="dropdownMenu"
          class="dropdown-menu"
          :style="{ 'max-height': maxHeight, 'margin-top': dropDownMarginClass }"
        >
          <li
            v-for="(option, index) in filteredOptions"
            :key="index"
            :class="{
              active: isOptionSelected(option),
              highlight: index === typeAheadPointer
            }"
            @mouseover="!multiple && (typeAheadPointer = index)"
          >
            <div class="dropdown-item" :class="className ? '' : 'flexStartAlign'" @mousedown.prevent="onMouseDown(option)">
              <input
                :id="$vId(this, 'fou-select-option-' + index)"
                class="cursor-pointer"
                :class="className"
                :data-qa-id="dataQaId"
                placeholder=" "
                :type="type"
                :checked="isOptionSelected(option)"
                :disabled="disableOptionsList.includes(option.value)"
                @click.prevent="isOptionSelected(option)"
              >
              <label class="cursor-pointer input-label" :for="$vId(this, 'fou-select-option-' + index)" >
                <span />
                <span>
                  {{ getOptionLabel?.(option) }}
                  <span v-if="option.subTitle" class="fou-select__sub-title">{{ option.subTitle }}</span>
                </span>
              </label>
            </div>
          </li>
          <li v-if="!filteredOptions.length" class="no-options">
            <slot name="no-options">
              <span>{{ $t('components.forms.fou_select.nomatch') }}</span>
            </slot>
          </li>
        </ul>
      </transition>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import vSelect from 'vue-select'
import {Obj} from 'src/utils/helper/object'
import Misc from 'src/utils/helper/misc'
import { isEmpty, isEqual } from 'lodash'

export default {
  name: 'FouSelect',
  mixins: [vSelect],
  props: {
    showLabel:{
      type:Boolean,
      default:false
    },
    labelClass:{
      type:String,
      default:'label-class'
    },
    labelName:{
      type:String,
      default:'label-name'
    },
    searchable: {
      type:Boolean,
      default: true
    },
    id: {},
    onChange: {
      type: [Function, Array],
      default: () => {
      }
    },
    tagsOutside: {
      type: Boolean,
      default: false
    },
    /**
     * An optional callback function that is called each time on keydown Enter event and returns the search value of the input.
     * @type {Function}
     * @default {null}
     */
    onEnter: {
      type: Function,
      default: function () {
      }
    },
    onDelete: {
      type: Function,
      default: function () {
      }
    },
    /**
     * An optional callback function that is called each time on Focus.
     */
    onFocus: {
      type: Function,
      default: function () {
      }
    },
    /**
     * Pass options for vee-validate.
     */
    vee: {
      type: Object,
      default: function () {
        /**
         * Use vee parameter to pass v-validate options.
         * Find possible oprtions in computed.veeValidate
         */
        return {}
      }
    },
    name: {
      type: String,
      required: true
    },
    /**
     * Addition: Added default.
     * Sets the id of the input element.
     * @type {String}
     * @default {null}
     */
    inputId: {
      type: String,
      default: ''
    },
    /**
     * force to hide dropdown
     */
    hideDrop: {
      type: Boolean,
      default: false
    },
    /**
     * Warning class
     */
    isWarning: {
      type: Boolean,
      default: false
    },
    isError:{
      type:Boolean,
      default:false
    },
    /**
     * Maxlength attribute to limit characters
     */
    maxLength: {
      type: String,
      default: ''
    },
    see: {
      type: String,
      default: 'triangle'
    },
    splitTagsLen: {
      type: Number,
      default: null
    },
    /**
     * disabled props to disable the input field
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * disableAutoComplete props to disable auto complete in the input field
     */
    disableAutoComplete: {
      type: Boolean,
      default: false
    },
    /**
     * disableOptionsList props to diable list of options
     */
    disableOptionsList: {
      type: Array,
      default: () => ([])
    },
    /**
     * prop for multi select with no search
     */
    isMulitpleSelectWithNoSearch: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    },
    className: {
      type: String
    },
    inputClass: {
      type: String
    },
    clearSearchOnBlur:{
      type:[Function, Boolean],
      default:()=> {}
    },
    customField: {
      type: String,
      default: ''
    },
    dataQaId:{
      type:String,
      default:''
    },
    foundriesCount:{
      type:Number,
      default:3
    },
    placeholderName:{
      type:String,
      default:'Foundries'
    },
    foundryArray : {
      type: Array
    },
    /**
     * Truncate long single-select labels with ellipsis (opt-in; default off).
     */
    truncateLabel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputValueInSingleString: '',
      previousValue: null
    }
  },
  computed: {
    updatedArray() {
      return this.foundryArray
    },
    dropDownMarginClass(){
      return this.showLabel? '0.5rem': '0rem'
    },
    maxHeight(){
      return '390px'
    },
    valueAsArray() {
      if (this.multiple && this._value) {
        return this._value
      } else if (this._value) {
        return [].concat(this._value)
      }
      return []
    },
    veeValidate() {
      /**
       * Merge Default validate options with props.
       */
      return {
        rules: {},
        as: this.name,
        scope: `fou-select_${this.id}`,
        ...this.vee
      };
    },
    firstField() {
      return {
        label: (this.valueAsArray || []).length > 0 ? this.valueAsArray[0].label : ''
      }
    },
    /**
     * Return the placeholder string if it’s set
     * & there is no value selected.
     * @return {String} Placeholder text
     */
    searchPlaceholder() {
      if ((this.isValueEmpty || this.multiple)) {
        return this.placeholder
      }
      return ''
    },
    /**
     * Addition: Added select--error
     * Classes to be output on .dropdown
     * @return {Object}
     */
    dropdownClasses() {
      return {
        open: this.dropdownOpen,
        single: !this.multiple,
        searching: this.searching,
        searchable: this.searchable,
        unsearchable: !this.searchable,
        loading: this.mutableLoading,
        customWidth: isEmpty(this._value) || this.search,
        customstyle: this.customField == 'region' || this.customField == 'customized' || this.customField == 'address'
      }
    }
  },
  watch: {
    /**
     * Addition: Added Validation and event.
     * @param  {string|object} val
     * @param  {string|object} old
     * @return {void}
     */
    _value(val, old) {
      this.$nextTick(() => {
        this.$events?.$emit('fou-select-tags:update')
      })
    },

    updatedArray(newVal,oldval){
      this._value = newVal
      this.isOptionSelected(this._value)
    },
    valueAsArray(newVal) {
      if (this.isMulitpleSelectWithNoSearch) {
        // Get the foundries string
        const foundriesString = this.getFoundriesString(newVal, this.foundriesCount, this.placeholderName);

        // Update the `_value` property based on the new value
        this._value = this.updateValueForAllOptions(newVal, this.placeholder);

        // Update the input value in a single string
        this.inputValueInSingleString = isEqual(newVal.length, 1) ? newVal[0].label : foundriesString;
      }
    }
  },
  created() {
    if (this.isMulitpleSelectWithNoSearch) {
      this._value = [{
        label: `${this.placeholder}`,
        value: 'all-options'
      }]
    }
  },
  methods: {
    getFoundriesString(newVal, foundriesCount, placeholderName) {
      if (isEqual(newVal.length, 0)) {
        return 'All Foundries';
      }

      const filteredValues = newVal.filter((data) => data.value !== 'all-options');
      if (filteredValues.length <= foundriesCount) {
        return filteredValues.map(({ label }) => label).join(', ');
      }

      return `${filteredValues.length} ${placeholderName}`;
    },

    updateValueForAllOptions(newVal, placeholder) {
      if (isEqual(newVal.length, 0)) {
        return [
          {
            label: `${placeholder}`,
            value: 'all-options',
          },
        ];
      }

      if (!isEqual(newVal.length, 1) && newVal.some((data) => data.value === 'all-options')) {
        return newVal.filter((data) => data.value !== 'all-options');
      }

      if (!isEqual(newVal.length, 1) && newVal[newVal.length - 1].value === 'all-options') {
        return newVal.filter((data) => data.value === 'all-options');
      }

      return newVal;
    },
    onMouseDown(option) {
      if (!this.disableOptionsList.includes(option.value)) {
        this.select(option);
        if (this.onChange) {
          if (typeof this.onChange === 'function') {
            this.onChange(option);
          } else if (Array.isArray(this.onChange)) {
            this.onChange.forEach(func => {
              if (typeof func === 'function') {
                func(option);
              }
            });
          }
        }
      }
    },
    searchForbidden() {
      return this.hideDrop
    },
    typeAheadSelect(tagsModel) {
      const tags = tagsModel.split(',')
      if (tags.length > this.splitTagsLen) {
        this.search = tagsModel
      } else {
        const updatedTagModel = tags.filter(v => !Misc.validateSize(v, 30)).join(',')
        this.search = updatedTagModel
      }
    },
    /**
     * NOTE: This function is from vSelect, but overwritten since object comparison was not exact.
     * Check if the given option is currently selected based on value(ID) & label(name).
     * @param  {Object|String}  option
     * @return {Boolean} True when selected | False otherwise
     */
    isOptionSelected(option) {
      if (this.multiple && this._value) {
        let selected = false
        this._value.forEach(opt => {
          if (typeof opt === 'object') {
            if (opt['value'] === option['value'] || opt[this.label] === option[this.label] || opt[this.label] === option) {
              selected = true;
            }
          } else if (opt === option) {
            selected = true;
          }
        })
        return selected
      }
      return Obj.is(this._value) && Obj.is(option)
        ? Obj.compare(this._value, option)
        : this._value === option
    },
    /**
     * Addition: Added Validation.
     * Close the dropdown on blur.
     * @emits  {search:blur}
     * @return {void}
     */
    onSearchBlur() {
      if (isEmpty(this._value)) {
        this._value = this.previousValue
        this.$emit('update:modelValue', this._value)
      }
      if (this.clearSearchOnBlur) {
        this.search = ''
      }

      const isValidSearch = this.options.some((option) => this.search === option.label)
      if(!isValidSearch) {
        this.search = ''
      }

      this.open = false
      this.$emit('search:blur')
    },
    /**
     * Addition: Added Set Validation Flags.
     * Close the dropdown on blur.
     * @emits  {search:blur}
     * @return {void}
     */
    onSearchFocus() {
      this.previousValue = this._value;
      this.onFocus(this.search)
    },
    getId() {
      return this.id || this.inputId
    },
    /**
     * Addition: tagsOutside
     * Delete the value on Delete keypress when there is no
     * text in the search input, & there's tags to delete
     * @return {this.value}
     */
    maybeDeleteValue() {
      if (!this.$refs.search.value.length && !this.tagsOutside && this._value) {
        if (this.multiple) {
          this._value.pop()
        } else {
          this._value = []
          this.$emit('update:modelValue', [])
        }
      }
    },
    updateDropdownstyle() {
      const allElem = document.querySelectorAll('.dropdown-toggle')
      allElem.forEach((e) => {
        if(e.querySelector(':nth-child(2)').classList.contains('spinner')) {
          const dropdwonElem = e.querySelector(':nth-child(2)')
          dropdwonElem.style.width = '2rem'
          dropdwonElem.style.height = '2rem'
          dropdwonElem.style.top = '2px'
      } else {
          const dropdwonElem = e.querySelector(':nth-child(2)')
          if(dropdwonElem.classList.contains('full-width')){
            dropdwonElem.style.width = '100%'
          }else{
            dropdwonElem.style.width = '1rem'
          }
      }
    })
    if(document.querySelector(".v-select.open") && document.querySelector(".v-select.open").querySelector(':nth-child(2)') && !document.querySelector(".v-select.open").querySelector(':nth-child(2)').classList.contains('open-indicator') && !document.querySelector('.v-select.open').querySelector(':nth-child(2)').classList.contains('search-indicator')) {
      document.querySelector(".v-select.open").querySelector(':nth-child(2)').style.width = '95%'
    }
  }
},
  updated () {
    this.updateDropdownstyle()
  },
  mounted() {
    this.updateDropdownstyle()
  }
}
</script>
<style lang="scss" src="./stylesheets/index.scss"></style>
